import { Text as ChakraText, TextProps as ChakraTextProps } from '@chakra-ui/react';
import PropTypes from 'prop-types';
import React from 'react';

import { getFontFromVariant } from '../../_helpers';
import { InferPropTypes } from '../../types';

/*
 * Renders a tabular text component used for standalone Numbers
 *
 * @prop {ReactNode} children -> The child node that renders inside of the component
 * @prop {String (Enumerable)} fontSize -> Describes the font-size style of the component
 * @prop {String (Enumerable)} fontWeight -> Describes the font-weight style of the component
 * @prop {String (Enumerable)} textAlign -> Aligns text to left or right
 */

const propTypes = {
  children: PropTypes.node.isRequired,
  fontSize: PropTypes.oneOf(['sm', 'md', 'lg', 'xl', '2xl', '3xl']),
  fontWeight: PropTypes.oneOf(['normal', 'medium', 'semibold']),
  textAlign: PropTypes.oneOf(['right', 'left'])
};

const defaultProps = {
  fontSize: 'md',
  fontWeight: 'medium',
  textAlign: 'right'
};

export type NumberProps = ChakraTextProps & InferPropTypes<typeof propTypes, typeof defaultProps>;

export default function Number(props: NumberProps): React.ReactElement {
  const { children, textAlign, fontWeight, ...rest } = props;

  const fontFamily = getFontFromVariant('base', fontWeight);

  return (
    <ChakraText fontFamily={fontFamily} fontWeight={fontWeight} textAlign={textAlign} {...rest}>
      {children}
    </ChakraText>
  );
}

Number.propTypes = propTypes;

Number.defaultProps = defaultProps;
